<template>
  <div
    ref="panel"
    :class="[{dark: isDark}, 'subscribe-panel-mini']"
  >
    <div class="artwork-meta">
      <Artwork />
      <MetaInfo />

      <Speed class="speed-mini" />
      <a
        :href="episodeUrl"
        class="share"
        target="simplecast-share"
      >
        <icon-share />
      </a>
      <div class="subscribe-tiny-items">
        <a
          href="#"
          class="subscribe-close-btn"
          @click.prevent="toggleSubscribe">
          <IconClose />
        </a>
        <IconLogo class="mini-logo" />
      </div>
    </div>
  </div>
</template>

<script>
import Artwork from './Artwork'
import IconClose from '../assets/svg/close.svg'
import IconShare from '../assets/svg/share-mini.svg'
import IconLogo from '../assets/svg/sc-logo.svg'
import MetaInfo from './MetaInfo'
import Store from '../store'
import Speed from './Speed'

export default {
  components: {
    Artwork,
    IconClose,
    IconLogo,
    IconShare,
    MetaInfo,
    Speed
  },
  data () {
    return { store: Store }
  },
  computed: {
    episodeUrl () { return this.store.state.episode.episode_url + '?share=true' },
    isDark () { return this.store.state.isDark }
  },
  methods: {
    toggleSubscribe () {
      this.store.setShowSubscribe(!this.store.state.showSubscribe)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'node_modules/simplecast-styles/src/assets/styles/_core/colors.scss';

.subscribe-panel-mini {
  box-sizing: border-box;
  padding: 8px 8px 0 0;
  position: absolute;
  right: 0;
  top: 0;
  width: calc(100% - 50px);
  z-index: 10;

  .artwork {
    height: 36px;
    margin-right: 8px;
    width: 36px;
  }
  .artwork-meta {
    display: flex;
  }
  .meta-info {
    flex: 1;
    /deep/ h2 {
      display: none;
    }
    /deep/ h1 {
      @media (max-width: 399px) {
        line-height: 36px;
      }
    }
    @media (min-width: 400px) {
      /deep/ .powered-by {
        display: block;
      }
    }
  }
  .share {
    align-items: center;
    background: none;
    border-radius: 4px;
    border: solid 1px $black-800;
    box-sizing: border-box;
    color: $black-800;
    display: flex;
    height: 36px;
    justify-content: center;
    opacity: .95;
    padding-bottom: 2px;
    position: relative;
    transition: opacity .2s ease;
    width: 36px;
    z-index: 10;
    &:hover {
      opacity: .6;
    }
  }

  &.dark {
    .share {
      border: solid 1px $white-000;
      color: $white-000;

      svg {
        fill: $white-000;
      }
    }
  }
}

.subscribe-tiny-items {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: 8px;
  height: 36px;
}

.subscribe-close-btn {
  border: 1px solid $black-800;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 14px;
  height: 14px;
  opacity: .95;
  &:hover {
    opacity: .6;
  }
  svg {
    display: block;
    height: 10px;
    width: 10px;
  }
  .dark & {
    border: 1px solid $white-000;
    svg {
      fill: $white-000
    }
    &:hover {
      border: 1px solid $white-000;
      svg {
        fill: $white-000
      }
    }
  }
}

button.speed-mini {
  height: 36px;
  width: 36px;
  margin-right: 8px;
  opacity: .95;
}

.mini-logo {
  width: 16px;
  height: 16px;
  display: block;
  g {
    fill: $black-trans-500;
  }
  .dark & g {
    fill: $white-trans-500;
  }
}
</style>
